import { render } from "./postView.vue?vue&type=template&id=56ef6508&scoped=true"
import script from "./postView.vue?vue&type=script&lang=js"
export * from "./postView.vue?vue&type=script&lang=js"

import "./postView.vue?vue&type=style&index=0&id=56ef6508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ef6508"]])

export default __exports__